export const api_url = process.env.REACT_APP_APP_ENVIRONMENT === 'prod' ? 'https://optobot.herokuapp.com' : 'https://optobot-test.herokuapp.com';
